import { render, staticRenderFns } from "./mobile_spot_order_manage.vue?vue&type=template&id=563bda98&scoped=true&"
import script from "./mobile_spot_order_manage.vue?vue&type=script&lang=js&"
export * from "./mobile_spot_order_manage.vue?vue&type=script&lang=js&"
import style0 from "./mobile_spot_order_manage.vue?vue&type=style&index=0&id=563bda98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563bda98",
  null
  
)

export default component.exports